/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export default angular.module('agrolog.api.user', [])
    .factory('agUserService', UserService)
    .name;

const agrologCustomerName = 'Agrolog Customer';

/*@ngInject*/
function UserService($q, $rootScope, types, entityService, customerService, assetService, deviceService, userService) {

    var agrologCustomer;

    var service = {
        getAgrologCustomer: getAgrologCustomer,
        assignAssetToCustomer: assignAssetToCustomer,
        assignDeviceToCustomer: assignDeviceToCustomer
    };

    $rootScope.agUserUnauthenricatedHandle = $rootScope.$on('unauthenticated', () => {
        agrologCustomer = null;
    });

    $rootScope.agUserAuthenricatedHandle = $rootScope.$on('authenticated', () => {
        agrologCustomer = null;
    });

    return service;


    function getAgrologCustomer() {
        var deferred = $q.defer();
        if (agrologCustomer) {
            deferred.resolve(agrologCustomer);
        } else {
            fetchAgrologCustomer().then(
                (customer) => {
                    deferred.resolve(customer);
                },
                () => {
                    deferred.reject();
                }
            );
        }
        return deferred.promise;
    }

    function assignAssetToCustomer(asset) {
        var deferred = $q.defer();
        getAgrologCustomer().then(
            (agCustomer) => {
                assetService.assignAssetToCustomer(agCustomer.id.id, asset.id.id).then(
                    () => {
                        deferred.resolve(asset);
                    },
                    () => {
                        deferred.reject();
                    }
                );
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function assignDeviceToCustomer(device) {
        var deferred = $q.defer();
        getAgrologCustomer().then(
            (agCustomer) => {
                deviceService.assignDeviceToCustomer(agCustomer.id.id, device.id.id).then(
                    () => {
                        deferred.resolve(device);
                    },
                    () => {
                        deferred.reject();
                    }
                );
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function fetchAgrologCustomer() {
        var deferred = $q.defer();
        var authority = userService.getAuthority();
        if (authority == 'TENANT_ADMIN') {
            entityService.getEntitiesByNameFilter(types.entityType.customer, agrologCustomerName, 1).then(
                (customers) => {
                    if (customers && customers.length) {
                        agrologCustomer = customers[0];
                        deferred.resolve(customers[0]);
                    } else {
                        deferred.reject();
                    }
                },
                () => {
                    deferred.reject();
                }
            );
        } else if (authority == 'CUSTOMER_USER') {
            var customerId = userService.getCurrentUser().customerId;
            customerService.getCustomer(customerId).then(
                (customer) => {
                    agrologCustomer = customer;
                    deferred.resolve(customer);
                },
                () => {
                    deferred.reject();
                }
            );
        } else {
            deferred.reject();
        }
        return deferred.promise;
    }
}
